import api from "../../index";

export const GetAllPaymentGatwaysApi = (params) => api.get(`paymentgateway/admin/payment-gateway-details?${params}`);
export const UpdatePaymentGatwayStatusApi = (params) => api.patch('paymentgateway/admin/payment-gateway-status-update', params);
export const UpdategetwayApi = (params) => api.put('paymentgateway/update-payment-getway', params);